import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoService, IBaseDto } from './base-dto.service';
import { MarketClient } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class MarketService extends BaseDtoService {
    constructor(private readonly client: MarketClient) {
        super();
    }

    async getAll(): Promise<IBaseDto[]> {
        return await lastValueFrom(this.client.marketGetAll());
    }

    async getById(id: number): Promise<IBaseDto> {
        return await lastValueFrom(this.client.marketGetById(id));
    }

    async getByIds(ids: number[]): Promise<IBaseDto[]> {
        return await lastValueFrom(this.client.marketGetByIds(ids));
    }
}
